import getReadableDateTimeString from './getReadableDateTimeString';

const getReadableDateString = (dateString: string) => {
  const dateTimeString = getReadableDateTimeString(dateString);

  return dateTimeString?.split?.(',')?.[0];
};

export default getReadableDateString;
